import API from "../../services/api";

export function fetchEmployeeSalaryRegister(params = {}) {
  return API.get("/payrolls/reports/employee-salary-register", { params });
}

export function exportEmployeeSalaryRegister(params = {}) {
  return API.get("/payrolls/reports/employee-salary-register/export", {
    params,
    responseType: "blob",
  });
}
